import React from "react";

const EmployeeName = ({ row }) => {
  return <div>{row?.employee?.employeeName}</div>;
};

export default EmployeeName;
